import React from 'react';
import { withRouter } from '../../../../common/utils/NavigationWrapper';

import { TextField, MenuItem, TableCell, TableRow, TableBody, Table } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Tile from '../../../../common/components/Tile/Tile';
import './FleetSummary.css';
import Utils from '../../../../common/utils/Utils';
import moment from 'moment';
import Loading from '../../../../common/components/Loading/Loading';
import Constants from '../../../../common/constants/Constants';

const constructLinkList = (links, currentPath, onChange) =>
  links.length == 0 ? null : (
    <TextField
      variant="standard"
      select={true}
      fullWidth
      onChange={(e) => onChange(e.target.value)}
      label="Navigate to"
      value={currentPath}
      data-qa="qa-fleet-navigate"
    >
      {links.map((link, index) => (
        <MenuItem key={index} value={link.path}>
          {link.name}
        </MenuItem>
      ))}
    </TextField>
  );

const FleetSummary = (props) => {
  const { selectedFleet, dropdownList, currentPath, onChange } = props;

  return (
    <Tile className="fleet-summary" title="Fleet summary" helpTag="fleet_summary">
      {constructLinkList(dropdownList, currentPath, onChange)}
      <div className="u-mb-half">
        {
          <Loading condition={props.fleets.length === 0}>
            <Autocomplete
              clearIcon={null}
              data-qa={`qa-SelectfleetAutocomplete`}
              style={{ width: '100%' }}
              options={props.fleets.sort((a, b) => -b.Name.localeCompare(a.Name))}
              autoHighlight
              getOptionLabel={(option) => (option.Name != undefined ? option.Name : option)}
              value={selectedFleet.fleetName || null}
              onChange={(event, newValue) => {
                props.onChangeFleetSelection(newValue);
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <div data-qa={`qa-SelectFleetDropdown`}>{option.Name}</div>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  variant="standard"
                  {...params}
                  label="Select fleet"
                  margin="normal"
                  data-qa={`qa-SelectFleetTextField`}
                />
              )}
              isOptionEqualToValue={(option, value) => option.Name === value}
            />
          </Loading>
        }
      </div>
      <Table data-qa="qa-fleet-summary">
        <TableBody>
          <TableRow>
            <TableCell>No of instruments</TableCell>
            <TableCell>{selectedFleet.numberOfInstruments}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>No of Online instruments</TableCell>
            <TableCell>
              {selectedFleet.numberOfOnlineInstruments != null
                ? selectedFleet.numberOfOnlineInstruments
                : 'Not available'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>No of Blocked instruments</TableCell>
            <TableCell>
              {selectedFleet.numberOfBlockedInstruments != null
                ? selectedFleet.numberOfBlockedInstruments
                : 'Not available'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Types of instruments</TableCell>
            <TableCell>
              {selectedFleet.typesOfInstruments == ''
                ? 'Not available'
                : selectedFleet.typesOfInstruments}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Software versions of instruments</TableCell>
            <TableCell>
              {selectedFleet.softwareVersionsOfInstruments == ''
                ? 'Not available'
                : selectedFleet.softwareVersionsOfInstruments}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Operating systems of instruments</TableCell>
            <TableCell>
              {selectedFleet.operatingSystemsOfInstruments == ''
                ? 'Not available'
                : selectedFleet.operatingSystemsOfInstruments}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>PC models of instruments</TableCell>
            <TableCell>
              {selectedFleet.pcModelsOfInstruments == ''
                ? 'Not available'
                : selectedFleet.pcModelsOfInstruments}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Longest offline instrument</TableCell>
            <TableCell>
              {selectedFleet.longestOfflineInstrument == ''
                ? 'Not available'
                : selectedFleet.longestOfflineInstrument}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Offline since</TableCell>
            <TableCell>
              {selectedFleet.offlineSince && selectedFleet.longestOfflineInstrument != ''
                ? Utils.FormatDateTime(moment(selectedFleet.offlineSince), props.globalSettings)
                : 'Not available'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>No of instruments with Alert status: Normal</TableCell>
            <TableCell>
              {selectedFleet.numberOfInstrumentsAlertSeverityNormal != null
                ? selectedFleet.numberOfInstrumentsAlertSeverityNormal
                : 'Not available'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>No of instruments with Alert status: Moderate</TableCell>
            <TableCell>
              {selectedFleet.numberOfInstrumentsAlertSeverityModerate != null
                ? selectedFleet.numberOfInstrumentsAlertSeverityModerate
                : 'Not available'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>No of instruments with Alert status: Severe</TableCell>
            <TableCell>
              {selectedFleet.numberOfInstrumentsAlertSeveritySevere != null
                ? selectedFleet.numberOfInstrumentsAlertSeveritySevere
                : 'Not available'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total no of tests in the last calendar month</TableCell>
            <TableCell>
              {selectedFleet.totalNumberOfTestsLastMonth != null
                ? selectedFleet.totalNumberOfTestsLastMonth
                : 'Not available'}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Tile>
  );
};

export default withRouter(FleetSummary);
